import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

/**
 * Legge dsa_mode_enabled / focus_mode_enabled dal profilo e applica le
 * classi corrispondenti su <html> per attivare gli stili globali.
 */
export function useProfileFlags() {
  const q = useQuery({
    queryKey: ["profile-flags"],
    queryFn: async () => {
      const { data: u } = await supabase.auth.getUser();
      if (!u.user) return { dsa: false, focus: false, dsaIntensity: "standard" as const };
      const { data } = await supabase
        .from("profiles")
        .select("dsa_mode_enabled,focus_mode_enabled,dsa_intensity")
        .eq("id", u.user.id)
        .maybeSingle();
      const raw = (data?.dsa_intensity ?? "standard") as string;
      const intensity: "light" | "standard" | "high" =
        raw === "light" || raw === "high" ? raw : "standard";
      return {
        dsa: !!data?.dsa_mode_enabled,
        focus: !!data?.focus_mode_enabled,
        dsaIntensity: intensity,
      };
    },
    staleTime: 30_000,
  });

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dsa-mode", !!q.data?.dsa);
    root.classList.toggle("focus-mode", !!q.data?.focus);
    root.classList.remove("dsa-intensity-light", "dsa-intensity-standard", "dsa-intensity-high");
    if (q.data?.dsa) {
      root.classList.add(`dsa-intensity-${q.data.dsaIntensity ?? "standard"}`);
    }
    return () => {
      // don't strip on unmount — layout is app-wide
    };
  }, [q.data?.dsa, q.data?.focus, q.data?.dsaIntensity]);

  return q.data ?? { dsa: false, focus: false, dsaIntensity: "standard" as const };
}